<div class="quote-progress" [@progress]="progressState" #quoteProgress>
  <div class="layer clouds" [@backgroundSlow]="animationState('slow')" (@backgroundSlow.done)="animationBackgroundDone('slow')">
    @for (sprite of this.sprites.clouds; track sprite) {
      <span [style.left]="sprite.left" [class]="sprite.color">
        <fa-icon [icon]="sprite.icon" size="3x"></fa-icon>
      </span>
    }
  </div>
  <div class="layer buildings" [@backgroundFast]="animationState('fast')" (@backgroundFast.done)="animationBackgroundDone('fast')">
    @for (sprite of this.sprites.buildings; track sprite) {
      <span [style.left]="sprite.left" [style.bottom]="sprite.bottom" [class]="sprite.color">
        <fa-icon [icon]="sprite.icon" [size]="sprite.size"></fa-icon>
      </span>
    }
  </div>
  <div class="truckLayer">
    <div class="truck" [style.left]="truckLeft$ | async">
      <fa-icon [icon]="truckIcon" size="4x" class="truck-icon"></fa-icon>
    </div>
  </div>
</div>
